import { CodeResponse, useGoogleLogin } from '@react-oauth/google'
import { apiClient } from '../lib/api'

interface GoogleDriveConnectButtonProps {
  driveCode?: CodeResponse
  onConnected: (driveCode: CodeResponse, oauthToken: unknown) => void
  disabled?: boolean
}

export default function GoogleDriveConnectButton({
  driveCode,
  onConnected,
  disabled = false,
}: GoogleDriveConnectButtonProps) {
  const connectGoogle = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      try {
        const response = await apiClient.generateGoogleOauthToken(codeResponse.code)
        if (response) {
          onConnected(codeResponse, response)
        }
      } catch (err) {
        console.error('Google OAuth token exchange failed', err)
      }
    },
    onError: () => {
      console.error('Google login failed')
    },
    scope: 'openid email profile https://www.googleapis.com/auth/drive.readonly',
    flow: 'auth-code',
  })

  return (
    <button
      type="button"
      disabled={disabled}
      className={`${
        driveCode ? 'bg-green-600 hover:bg-green-700' : 'bg-zinc-600 hover:bg-zinc-700'
      } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50`}
      onClick={() => connectGoogle()}
    >
      {driveCode ? 'Connected to Google Drive' : 'Connect Google Drive'}
    </button>
  )
}
